module.exports = __webpack_public_path__ + "img/特产店铺6.002f799b.png";